module.exports = "https://www.gc-pro.gnp.com.mx/8936633b930aa2ebacd78e2553d0740a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/camera.svg
// module id = 8067
// module chunks = 0